export type Holiday = 'THANKSGIVING' | 'CHRISTMAS';

export const PRIMARY_COLORS: Record<Holiday, string> = {
  THANKSGIVING: '#D67D00', // orange
  CHRISTMAS: '#bd0000', // red
  // CHRISTMAS: '#378b29', // a nice green in case we want to use it
};

export const SECONDARY_COLORS: Record<Holiday, string> = {
  THANKSGIVING: '#ffc97d', // light orange
  CHRISTMAS: '#ff9494', // light red
  // CHRISTMAS: '#74d681', // a nice light green in case we want to use it
};
